import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { TeacherSubstitutionResultGraphqlDto } from "../../gql/graphql.ts";

const Try1on1PlanSlotTeacherSubstitutionMutation = gql`
  mutation try1on1PlanSlotTeacherSubstitution(
    $planId: String!
    $teacherId: String!
    $slots: [AddLessonTo1on1PlanSlotInput!]!
  ) {
    try1on1PlanSlotTeacherSubstitution(
      planId: $planId
      teacherId: $teacherId
      slots: $slots
    ) {
      successfulSubstitutions {
        classRoomId
        startDateUtc
        endDateUtc
        originalTeacher {
          id
          email
          givenName
          familyName
          lesson1on1
        }
        newTeacher {
          id
          email
          givenName
          familyName
          lesson1on1
        }
      }
      failedSubstitutions {
        classRoomId
        startDateUtc
        endDateUtc
        reason
        teacher {
          id
          email
          givenName
          familyName
          lesson1on1
        }
      }
    }
  }
`;

type Response = {
  try1on1PlanSlotTeacherSubstitution: TeacherSubstitutionResultGraphqlDto;
};

export function useTry1on1PlanSlotTeacherSubstitution() {
  const [mutate, { loading }] = useMutation<Response>(
    Try1on1PlanSlotTeacherSubstitutionMutation,
  );

  const trySubstitution = useCallback(
    async (params: {
      planId: string;
      teacherId: string;
      slots: Array<{ startUtc: string; endUtc: string }>;
    }): Promise<TeacherSubstitutionResultGraphqlDto> => {
      const result = await mutate({ variables: params });
      return result.data!.try1on1PlanSlotTeacherSubstitution;
    },
    [mutate],
  );

  return { trySubstitution, loading };
}
